import { render, staticRenderFns } from "./ModalTag.vue?vue&type=template&id=3606df8c"
import script from "./ModalTag.vue?vue&type=script&lang=js"
export * from "./ModalTag.vue?vue&type=script&lang=js"
import style0 from "./ModalTag.vue?vue&type=style&index=0&id=3606df8c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3606df8c')) {
      api.createRecord('3606df8c', component.options)
    } else {
      api.reload('3606df8c', component.options)
    }
    module.hot.accept("./ModalTag.vue?vue&type=template&id=3606df8c", function () {
      api.rerender('3606df8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/batch/ModalTag.vue"
export default component.exports